import React, { useEffect, useState } from "react";
import { Button, Form, Flex, Row, Col, Input } from "antd";
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import { IconPrimary, Popup } from "../components";
import { PlusOutlined } from "@ant-design/icons";
import { usePopup } from "../hooks/usePopup";
import { EditIcon } from "../assets";
import { Announcement } from "../redux/apiSlice/announcementSlice";
import handleApiError from "../utils/handleError";
import axiosClient from "../api/axiosClient";
import { getSupportTickets } from "../redux/apiActions/supportAction";
import { useAppDispatch } from "../redux/hooks";

type Props = {
  record?: Announcement;
};

const SupportForm: React.FC<Props> = ({ record }: Props) => {
  const [form] = useForm();
  const popup = usePopup();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const onFinish = async (data: any) => {
    setLoading(true);
    try {
      await axiosClient.post("/support/ticket", data);
      dispatch(getSupportTickets());
      popup.close();
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (record) {
      form.setFieldsValue(record);
    }
    return () => form.resetFields();
  }, [record, form]);

  return (
    <Popup
      ref={popup.popupRef}
      openTrigger={
        record ? (
          <IconPrimary>
            <EditIcon />
          </IconPrimary>
        ) : (
          <Button icon={<PlusOutlined />}>Raise Incident</Button>
        )
      }
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={record}
        onFinish={onFinish}
      >
        <Row justify="center" style={{ marginTop: "30px" }}>
          <Col span={18}>
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Title is required" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Message"
              name="message"
              rules={[{ required: true, message: "Message is required" }]}
            >
              <TextArea rows={5} />
            </Form.Item>

            <Flex justify={"center"}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  ghost
                  disabled={loading}
                  loading={loading}
                >
                  Submit
                </Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
    </Popup>
  );
};

export default SupportForm;
